import { Box, Icon, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const PageHeaderAppraisal = ({ evaluationTitle }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  return (
    <Box
      sx={{
        width: '100%',
        height: 75,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white.main',
        borderBottom: '1px solid',
        borderBottomColor: 'gray-line.main',
        position: 'sticky',
        top: 0,
        zIndex: 999,
      }}
      px={'40px'}
    >
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        <Typography fontWeight="bold">{evaluationTitle}</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={3}>
        <Icon
          onClick={() => {
            state?.appraisalTabsValue === 2
              ? navigate(`/app/appraisal-cycle/details/${state.item.id}`, {
                  state: {
                    ...state,
                    initialTabsValue: 2,
                  },
                })
              : navigate(`/app/appraisal-cycle/evaluation/${state.item.id}`, {
                  state: {
                    ...state,
                    evaluationTabsValue: 1,
                  },
                })
          }}
          sx={{ fontSize: 25, cursor: 'pointer' }}
        >
          close
        </Icon>
      </Box>
    </Box>
  )
}

export default PageHeaderAppraisal
